<div class="eb-shipping-address__delete-address-modal">
  <div class="cx-modal-content">
    <div class="modal__wrapper">
      <ng-container>
        <div class="modal__header">
          <div class="modal__title">
            <h3>{{ 'shippingAddress.delete.title' | cxTranslate }}</h3>
            <button
              type="button"
              class="modal__close"
              (click)="dismissModal('cross click')"
              data-cy="modal-close"
            >
              <em class="fas fa-times"></em>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <div class="eb-shipping-address__delete-card-container">
            <eb-card
              [fitToContainer]="true"
              [content]="getCardContent()"
              class="eb-shipping-address__address-card"
            ></eb-card>
          </div>
          <form (ngSubmit)="deleteAddress()">
          <div class="eb-shipping-address__edit-address-modal-action-buttons">
            <a
              class="eb-shipping-address__edit-address-modal-cancel"
              (click)="dismissModal('cancel')"
            >
              {{ 'shippingAddress.delete.cancel' | cxTranslate }}
            </a>
            <button type="submit" class="eb-shipping-address__edit-address-modal-submit">
              {{ 'shippingAddress.delete.confirmation' | cxTranslate }}
            </button>
          </div>
          </form>
          <eb-info-box icon="info-circle" [infoType]="'INFO'" class="eb-shipping-address__info-box">{{
            'shippingAddress.delete.note' | cxTranslate
            }}</eb-info-box>
        </div>
      </ng-container>
    </div>
  </div>
</div>
